
import { Variables } from "../../variables";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class PanamaLayout extends Vue {
  @Prop() readonly roles!: [];
  private showNav = false;

  get panamaDigitalPath() {
    return Variables.PanamaDigitalPath;
  }

  get fileAssets() {
    return Variables.FileAssets == "/"
      ? Variables.FileAssets
      : `${Variables.FileAssets}/`;
  }

  get title() {
    return Variables.Title;
  }

  get pathAdmin() {
    return `${Variables.ApiBaseUrl}/admin`;
  }

  get pathProfile() {
    return `${Variables.ApiBaseUrl}/account/profile`;
  }

  get pathLogout() {
    return `${Variables.ApiBaseUrl}/account/logout`;
  }
}
